import Vue from 'vue';

Vue.filter("formatDateTime", function(value, hasTime = false) {
  if (value) {
    let date = new Date(`${value}`);
		date = new Date(date.toString().replace("Standard", "Daylight"));
	let time = date.toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'});
	let dateString = date.toLocaleDateString('en-GB');

	return hasTime ? `${dateString} ${time}` : dateString;
  }
});

Vue.filter("formatDateTimeNew", function(value, hasTime = false) {
  if (value) {
    const date = new Date(value);

    const time = date.toLocaleTimeString('en-AU', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Australia/Sydney'
    });

    const dateString = date.toLocaleDateString('en-GB', {
      timeZone: 'Australia/Sydney'
    });

    return hasTime ? `${dateString} ${time}` : dateString;
  }
});

Vue.filter("formatStatus", (status) => {

	let statusArray = {
		0: "Cancelled",
		1: "Rejected",
		2: "New",
		3: "In Progress",
		4: "Completed",
		5: "Signed",
		6: "Unknown"
	};

	return statusArray[status];
});